import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import {
  Form,
  Button,
  Input,
  Label,
  FormFeedback,
  FormGroup,
} from 'reactstrap';
import { useFormik } from 'formik';
import { createOrUpdateBrand } from '../../../actions/organization';
import { alertError, alertSuccess } from '../../../helpers/errorHandling';
import { useDispatch, useSelector } from 'react-redux';
import InnerLoader from '../../../Components/Common/InnerLoader';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactSelect from 'react-select';

const CreateBrandForm = ({
  brandId = null,
  handleClose = () => {},
  isFromPopup = false,
}) => {
  const dispatch = useDispatch();
  const { countries, organizations, organizationTree } = useSelector(
    (state) => state?.organization
  );
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      name: '',
      organizationId: '',
      countries: [],
      isDisabled: false,
    },
    validationSchema: Yup.object({
      name: Yup.string().required('Name is required'),
      organizationId: Yup.string().required('Organization is required'),
      countries: Yup.array().min(1, 'Select at least one country'),
    }),
    onSubmit: async (values) => {
      try {
        setLoading(true);

        const inputData = {
          input: {
            ...values,
          },
        };

        const res = await createOrUpdateBrand(inputData, dispatch);
        if (res?.brandId) {
          if (values?.brandId) {
            alertSuccess('Brand updated successfully');
          } else {
            alertSuccess('Brand created successfully');
          }
          if (isFromPopup) {
            setTimeout(() => {
              resetFormValues();
              handleClose();
            }, 1000);
          }
        } else {
          alertError('Failed, Please try again later');
        }
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      } catch (e) {
        console.log(e);
      }
    },
  });

  const {
    values,
    handleChange,
    handleBlur,
    touched,
    errors,
    handleSubmit,
    setFieldValue,
    resetForm,
    setValues,
  } = formik;

  const resetFormValues = () => {
    resetForm({
      values: {
        name: '',
        organizationId: '',
        countries: [],
        isDisabled: false,
      },
    });
  };

  useEffect(() => {
    try {
      if (brandId) {
        const brand = organizationTree?.brands?.find(
          (brand) => brand?.brandId === brandId
        );
        if (brand?.brandId) {
          setValues({
            name: brand?.name || '',
            organizationId: brand?.organizationId || '',
            countries: brand?.countries || [],
            isDisabled: brand?.isDisabled || false,
            brandId: brand?.brandId,
            isDeleted: brand?.isDeleted,
          });
        }
      } else if (organizationTree?.organizationId) {
        setValues({
          organizationId: organizationTree?.organizationId || '',
        });
      }
    } catch (e) {
      console.log(e);
    }
  }, [brandId, organizationTree]);

  return (
    <>
      <Form noValidate onSubmit={handleSubmit}>
        <FormGroup>
          <Label for="name">Name</Label>
          <Input
            type="text"
            name="name"
            id="name"
            value={values?.name}
            onChange={handleChange}
            onBlur={handleBlur}
            invalid={touched?.name && !!errors?.name}
          />
          <FormFeedback>{errors?.name}</FormFeedback>
        </FormGroup>

        <FormGroup>
          <Label for="organization">Organization</Label>
          <Input
            type="select"
            name="organizationId"
            id="organization"
            value={values?.organizationId}
            onChange={handleChange}
            onBlur={handleBlur}
            invalid={touched?.organizationId && !!errors?.organizationId}
          >
            <option value="">Select Organization</option>
            {organizations?.map((org, index) => (
              <option key={index} value={org?.organizationId}>
                {org?.name}
              </option>
            ))}
          </Input>
          <FormFeedback>{errors?.organizationId}</FormFeedback>
        </FormGroup>

        <FormGroup>
          <Label for="countries">Countries</Label>
          <ReactSelect
            id="countries"
            name="countries"
            isMulti
            options={countries?.map((country) => ({
              value: country?.countryCode,
              label: country?.name,
            }))}
            value={values?.countries?.map((countryCode) => {
              const country = countries?.find(
                (c) => c?.countryCode === countryCode
              );
              return country
                ? { value: country?.countryCode, label: country?.name }
                : null;
            })}
            onChange={(selectedOptions) => {
              const selectedValues = selectedOptions.map(
                (option) => option.value
              );
              setFieldValue('countries', selectedValues);
            }}
            onBlur={handleBlur}
            classNamePrefix="react-select"
          />
          {touched.countries && errors.countries && (
            <div className="invalid-feedback d-block">{errors.countries}</div>
          )}
        </FormGroup>

        {brandId && (
          <FormGroup className="d-flex align-items-center">
            <Label for="isDisabled" className="me-2 mb-0">
              Is Disabled
            </Label>
            <div className="form-switch">
              <Input
                type="switch"
                name="isDisabled"
                id="isDisabled"
                checked={values.isDisabled}
                onChange={handleChange}
              />
            </div>
          </FormGroup>
        )}

        <Button
          type="submit"
          color="primary"
          className="mt-2 bg-gradient px-5 "
          size="md"
        >
          {brandId ? 'Save' : 'Create'}
        </Button>
      </Form>
      {loading && <InnerLoader />}
      {/* <ToastContainer /> */}
    </>
  );
};

export default CreateBrandForm;
